// subscribePrivateGoalV2Channel.js
'use strict';
import * as MessageTypes from '../serviceWorker/AppMessageTypes.js';
import { sendMessageToSW } from '../serviceWorker/helpers.js';

/**
 * Subscribe private goal v2 channel
 * @kind action
 * @param {string} {goalId} - goal id.
 * @param {string} {userId} - user id.
 * @return {Promise} Action promise.
 */
const subscribePrivateGoalV2Channel =
  ({ goalId, userId }) =>
  async dispatch => {
    if (!goalId || !userId) {
      return dispatch({ type: '' });
    }
    return sendMessageToSW({
      type: MessageTypes.SUBSCRIBE_PRIVATE_GOAL_V2_CHANNEL,
      payload: {
        goalId,
        userId,
      },
    });
  };

export default subscribePrivateGoalV2Channel;
